/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import {
  TablePaginationConfig,
  TableRowSelection
} from 'antd/es/table/interface';
import { Table as HefestoTable, Pagination } from '@gerdau/hefesto-mais-web';
import { ColumnsType, FilterValue } from 'antd/lib/table/interface';

interface ITableProps<T> {
  columns: ColumnsType<T>;
  data: T[];
  hasPagination?: boolean;
  expandedRowRender?: (record: T) => React.ReactNode;
  rowSelection?: TableRowSelection<T>;
  pageSizeOptions?: number[];
  scroll?: {
    x?: number | true | string | 'max-content';
    y?: number | string | 'max-content';
  };
  expandedColumnPosition?: 'right' | 'left';
}

const Table = <GenericDataSource extends { key: React.Key }>({
  columns,
  data,
  hasPagination = false,
  rowSelection,
  expandedRowRender,
  pageSizeOptions,
  scroll,
  expandedColumnPosition = 'right'
}: ITableProps<GenericDataSource>) => {
  const [dataSource, setDataSource] = useState<GenericDataSource[]>([]);
  const [currentSorter, setCurrentSorter] = useState({
    order: 'ascend',
    column: { sorter: (): any => null }
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const slicedData = data.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );
    setDataSource(slicedData);
  }, [data]);

  const sorterHelper = (sorter: any) => {
    let itemHelper = [];
    if (sorter.order === 'ascend') {
      itemHelper = data.concat().sort(sorter.column.sorter);
    } else if (sorter.order === 'descend') {
      itemHelper = data.concat().sort(sorter.column.sorter).reverse();
    } else {
      itemHelper = data;
    }

    return itemHelper;
  };

  function handleTableSort(
    _pagination: TablePaginationConfig,
    _filters: Record<string, FilterValue | null>,
    sorter: any
  ) {
    const itemHelper = sorterHelper(sorter);

    const slicedItems = itemHelper.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );
    setDataSource(slicedItems);
    setCurrentSorter(sorter);
  }

  const sortItems = (newPage: number, newPageTotal: number) => {
    const itemHelper = sorterHelper(currentSorter);

    setDataSource(
      itemHelper.slice((newPage - 1) * newPageTotal, newPage * newPageTotal)
    );
  };

  function handleChange(current: number, pageSizeTable: number) {
    setCurrentPage(current);
    setPageSize(pageSizeTable);
    sortItems(current, pageSizeTable);
  }

  return (
    <>
      <HefestoTable
        expandedColumnPosition={expandedColumnPosition}
        columns={columns}
        dataSource={dataSource}
        onChange={handleTableSort}
        expandedRowRender={expandedRowRender}
        rowSelection={rowSelection}
        scroll={scroll}
      />
      {hasPagination && (
        <Pagination
          showTotal
          total={data.length}
          onChange={handleChange}
          pageSizeOptions={pageSizeOptions}
        />
      )}
    </>
  );
};

export default Table;
